module.exports = __webpack_public_path__ + "img/tti.9222013a.png";